import { cn, Skeleton } from "@nexus/ui"
import { OpportunitySetList } from "../../sets/OpportunitySetList/OpportunitySetList"
import { OpportunitiesTableFullSkeleton } from "../../table/OpportunitiesTable/OpportunitiesTableSkeletonRows"

export type OpportunitiesLoadingVariant = "sets" | "table"

export interface OpportunitiesLoadingStateProps {
  /**
   * `sets` — set selector + card grid (no set selected).
   * `table` — tabs + toolbar + table (workspace). Default `sets`.
   */
  variant?: OpportunitiesLoadingVariant
  /** Merged onto root. Use e.g. `p-0 gap-3` when embedded under OpportunitiesPage chrome. */
  className?: string
}

export function OpportunitiesLoadingState({
  variant = "sets",
  className,
}: OpportunitiesLoadingStateProps) {
  if (variant === "table") {
    return (
      <div className={cn("flex min-h-0 flex-1 flex-col transition-all duration-300 ease-in-out", className)}>
        <div className="flex flex-1 flex-col gap-4 overflow-hidden p-4">
          <div key="table-view" className="animate-in fade-in duration-200 flex min-h-0 flex-1 flex-col gap-3">
            <div className="flex flex-wrap gap-2">
              {Array.from({ length: 4 }).map((_, i) => (
                <Skeleton key={i} className="h-9 w-24 rounded-md" />
              ))}
            </div>
            <div className="flex flex-wrap items-center gap-2">
              <Skeleton className="h-9 min-w-[200px] flex-1 rounded-md" />
              {Array.from({ length: 5 }).map((_, i) => (
                <Skeleton key={i} className="h-9 w-[100px] rounded-md" />
              ))}
              <Skeleton className="h-9 w-9 shrink-0 rounded-md" />
            </div>
            <OpportunitiesTableFullSkeleton />
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className={cn("flex min-h-0 flex-1 flex-col transition-all duration-300 ease-in-out", className)}>
      <div className="flex flex-1 flex-col gap-4 overflow-hidden p-4">
        <div className="flex shrink-0 items-center gap-2">
          <Skeleton className="h-8 w-[200px] rounded-md" />
          <Skeleton className="h-8 w-44 rounded-md" />
        </div>
        <div className="animate-in fade-in duration-200 min-h-0 min-w-0 flex-1 overflow-y-auto overflow-x-visible">
          <OpportunitySetList sets={[]} isLoading onSelectSet={() => {}} />
        </div>
      </div>
    </div>
  )
}
